import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
    AuthorizationGuard,
    LsqBackendComponent,
    LsqClaimsComponent
} from '@lsq-frontend/common-ui';
import { Routes } from '@lsq-frontend/common-ui';
import { localAtlas } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { LsqUserStateManagementComponent } from './user-state/lsq-user-state-management.component';

export const localManagementRoutes: Routes = [
    {
        path: localAtlas.LOCAL_BACKEND.path,
        component: LsqBackendComponent,
        data: {
            title: localAtlas.LOCAL_BACKEND.title,
            environments: localAtlas.LOCAL_BACKEND.environments
        }
    },
    {
        path: localAtlas.LOCAL_CLAIMS.path,
        component: LsqClaimsComponent,
        canActivate: [AuthorizationGuard],
        data: {
            title: localAtlas.LOCAL_CLAIMS.title,
            environments: localAtlas.LOCAL_CLAIMS.environments
        }
    },
    {
        path: localAtlas.LOCAL_USER_STATE.path,
        component: LsqUserStateManagementComponent,
        canActivate: [AuthorizationGuard],
        data: {
            title: localAtlas.LOCAL_USER_STATE.title,
            environments: localAtlas.LOCAL_USER_STATE.environments
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(localManagementRoutes)],
    exports: [RouterModule]
})
export class LocalManagementRoutingModule {}
